export const ITEM_UPDATE_REQUEST = 'ITEM_QUANTITY_UPDATE_REQUEST';
export const ITEM_UPDATE_SUCCESS = 'ITEM_QUANTITY_UPDATE_SUCCESS';
export const ITEM_UPDATE_ERROR = 'ITEM_QUANTITY_UPDATE_ERROR';
export const UPDATE_ANALYTICS_CLICK_EVENT = 'UPDATE_ANALYTICS_CLICK_EVENT ';
export const CART_DETAILS_GET_REQUEST = 'CART_DETAILS_GET_REQUEST';
export const UPDATE_ZIPCODE_REQUEST = 'UPDATE_ZIPCODE_REQUEST';
export const UPDATE_ZIPCODE_REQUEST_SUCCESS = 'UPDATE_ZIPCODE_REQUEST_SUCCESS';
export const UPDATE_ZIPCODE_REQUEST_ERROR = 'UPDATE_ZIPCODE_REQUEST_ERROR';
